export default [
    {
      path: '/',
      redirect: '/login',
      // meta: {
      //   title: '登录'
      // }
    },
    
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index'),
      meta: {
        title: '天信人员管理系统'
      }
    },
    
    {
      path: '/main',
      name: 'main',
      component: () => import('@/views/main/index'),
      meta: {
        title: '天信人员管理系统'
      },
    },
    

]
  